import React from "react";
import moment from "moment";
import styles from "./LastUpdateTime.css";

interface Props {
  className?: string;
  lastUpdatedTime: number;
}

export const LastUpdateTime = ({ lastUpdatedTime }: Props) => (
  <div className={styles.container}>
    Posição do veículo atualizada {getLastUpdate(lastUpdatedTime)}
  </div>
);

const getLastUpdate = (lastUpdatedTime: number) => {
  const now = moment();
  const lastStatus = moment(lastUpdatedTime);
  if (now.isSame(lastStatus, "day")) {
    return lastStatus.format("[às] HH:mm");
  } else {
    return lastStatus.format("[em] DD/MM/YYYY [às] HH:mm");
  }
};
